export default {"src":"/_next/static/media/certificate.3aab43bb.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};